import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { RegularizationService } from '../Model/Regularization/regularization.service';
import { SessionService } from '../Util/Session/session.service';
import { AttendanceService } from '../Model/Attendance/attendance.service';
import { NgbActiveModal, NgbAlertModule, NgbDate, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbNavModule, NgbTimepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../Model/utility/utility.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { OutOfOfficeService } from '../Model/OutOfOffice/out-of-office.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import moment from 'moment';

@Component({
  selector: 'app-admin-regularization-request',
  standalone: true,
  imports: [NgbNavModule, NgbDatepickerModule, FormsModule, NgbAlertModule, NgbTimepickerModule, CommonModule, DataTablesModule, ReactiveFormsModule, NgbDropdownModule, RouterModule, NgbTooltip, LoaderComponent],
  templateUrl: './admin-regularization-request.component.html',
  styleUrl: './admin-regularization-request.component.scss'
})
export class AdminRegularizationRequestComponent {

  @Input() EmployeeId = 0;
  @Input() EmpType = '';

  dtTrigger: Subject<any> = new Subject<any>();
  isDisabled: boolean = false;

  Regularization = {
    RegularizationAttendanceDetails: [
      
    ] as any,
  };

  RegularizationForSave = {
    RegularizationAttendanceDetails: [
      
    ] as any,
  };

  AttendanceDetail = {
    IsCheckIn: false,//
    SelectType: 'InsertUpdate',//
    EmpMasterId: null as any,
    EmpCode: null,
    FUllName: null,
    DesignationID: null,
    DutyID: null,
    BranchID: null as any,//
    SiteId: null,
    ShiftID: null,
    ShiftCode: null,
    ShiftTitle: null,
    ID: null as any
  };

  constructor(
    private _Regularization: RegularizationService,
    private _Attendance: AttendanceService,
    private modalService: NgbModal,
    public common: CommonService,
    public toast: ToastService,
    public dateFormate: CustomDateParserFormatter,
    protected tooltip: TooltipService,
    private outofoffice: OutOfOfficeService,
    private activeModal: NgbActiveModal
  ) {
    
  }

  ngOnInit(): void {
    // this.AttendanceDetail.EmpMasterId = this.AttendanceDetail.ID == 0 ? this.session.GetUserDetails().UserId : this.AttendanceDetail.ID;
    this.AttendanceDetail.EmpMasterId = this.EmployeeId;
    this.AttendanceDetail.ID = this.EmployeeId;
    this.LoadData();
  }

  async LoadData() {
    await this.GetAttendanceDetails();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetAttendanceDetails(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._Attendance.GetAttendanceDetails({ EmpMasterId: this.AttendanceDetail.EmpMasterId, QRSiteID: 0 }).subscribe({
        next: (response) => {
          this.AttendanceDetail.EmpMasterId = response.Table[0].EmpMasterID;
          this.AttendanceDetail.EmpCode = response.Table[0].EmpCode;
          this.AttendanceDetail.FUllName = response.Table[0].FUllName;
          this.AttendanceDetail.DesignationID = response.Table[0].DesignationID;
          this.AttendanceDetail.DutyID = response.Table[0].DutyID;
          this.AttendanceDetail.BranchID = 0;
          this.AttendanceDetail.SiteId = response.Table[0].SiteID;
          this.AttendanceDetail.ShiftID = response.Table[0].ShiftID;
          this.AttendanceDetail.ShiftCode = response.Table[0].ShiftCode;
          this.AttendanceDetail.ShiftTitle = response.Table[0].ShiftTitle;

          resolve(true);
        },
        complete: () => { },
        error: (error) => { },
      });
    });
  }

  dateClass() {
    return (date: NgbDate) => {
      if (this.Regularization.RegularizationAttendanceDetails.findIndex((e: any) => e.AttendanceDate.isSame(date)) >= 0) {
        return 'special-date';
      } else {
        return '';
      }
    };
  }

  RegularizationDateSelect(event: any) {
    const selectedDate = moment(`${event.year}-${event.month}-${event.day}`, 'YYYY-MM-DD');
    const dayInWords = selectedDate.format('ddd');
    if (this.Regularization.RegularizationAttendanceDetails.findIndex((e: any) => moment(e.date).isSame(event)) >= 0) {
      this.toast.show({ message: 'Date already exist', type: toastTypeEnum.warning });
    } else {
      this.outofoffice.OutOfOfficeAttendanceDetails({
        SelectType: 1,
        ESS_OutOfOfficeAttendanceDetailsId: 0,
        EmpMasterID: this.AttendanceDetail.EmpMasterId,
        ApprovalStatus: '',
        FromDate: '',
        ToDate: '',
        BranchId: 0,
        ClientId: 0,
        SiteId: 0,
        AttendanceDate: this.dateFormate.format(event),
      }).subscribe({
        next: (response) => {
          if (response.Table.length > 0) {
            this.Regularization.RegularizationAttendanceDetails.push({
              date: event,
              dayInWords: dayInWords,
              EmpMasterId: this.AttendanceDetail.EmpMasterId,
              DesignationID: this.AttendanceDetail.DesignationID,
              DutyID: this.AttendanceDetail.DutyID,
              BranchID: this.AttendanceDetail.BranchID,
              SiteID: this.AttendanceDetail.SiteId,
              ShiftMasterID: response.Table[0]['ShiftMasterID'],
              AttendanceDate: this.dateFormate.format(event),
              InTime: response.Table[0]['InTime'] ? { hour: parseInt(response.Table[0]['InTime'].split(":")[0]), minute: parseInt(response.Table[0]['InTime'].split(":")[1]) } : null,
              OutTime: response.Table[0]['OutTime'] ? { hour: parseInt(response.Table[0]['OutTime'].split(":")[0]), minute: parseInt(response.Table[0]['OutTime'].split(":")[1]) } : null,
              InReason: null,
              OutReason: null,
              IsIn: false,
              IsOut: false,
              ShiftCode: response.Table[0]['ShiftCode'],
              ShiftTitle: response.Table[0]['ShiftTitle'],
            });
          } else {
            this.Regularization.RegularizationAttendanceDetails.push({
              date: event,
              dayInWords: dayInWords,
              EmpMasterId: this.AttendanceDetail.EmpMasterId,
              DesignationID: this.AttendanceDetail.DesignationID,
              DutyID: this.AttendanceDetail.DutyID,
              BranchID: this.AttendanceDetail.BranchID,
              SiteID: this.AttendanceDetail.SiteId,
              ShiftMasterID: this.AttendanceDetail.ShiftID,
              AttendanceDate: this.dateFormate.format(event),
              InTime: null,
              OutTime: null,
              InReason: null,
              OutReason: null,
              IsIn: false,
              IsOut: false,
              ShiftCode: this.AttendanceDetail.ShiftCode,
              ShiftTitle: this.AttendanceDetail.ShiftTitle,
            });
          }
        }
      })


    }
  }

  CardDelete(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want to delete?';

    modalRef.result.then((result: any) => {
      if (result) {
        this.Regularization.RegularizationAttendanceDetails.splice(index, 1);
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Regularization.RegularizationAttendanceDetails == null || this.Regularization.RegularizationAttendanceDetails.length <= 0) {
        this.toast.show({ message: 'Please select atleast one day ', type: toastTypeEnum.warning });
      } else if (this.Regularization.RegularizationAttendanceDetails.filter((e: any) => e.IsIn && e.InTime == null).length > 0) {
        this.toast.show({ message: 'Please enter in time ', type: toastTypeEnum.warning });
      } else if (this.Regularization.RegularizationAttendanceDetails.filter((e: any) => e.IsOut && e.OutTime == null).length > 0) {
        this.toast.show({ message: 'Please enter out time ', type: toastTypeEnum.warning });
      } else {
        this.SaveRegularizationAttendance();
      }
    }
    else {
      if (this.Regularization.RegularizationAttendanceDetails != null || this.Regularization.RegularizationAttendanceDetails.length <= 0) {
        this.toast.show({ message: 'Please select atleast one day ', type: toastTypeEnum.warning });
      }
      form.submitted = true;
    }
  }

  async SaveRegularizationAttendance() {
    // await this.common.getPageRights();
    this.RegularizationForSave.RegularizationAttendanceDetails = [];
    if (this.Regularization.RegularizationAttendanceDetails.some((e: any) => e.IsIn && e.IsOut && e.OutTime && e.InTime && moment(e.OutTime).isBefore(e.InTime) && !e.IsRotationalShift)) {
      this.toast.show({ message: 'OutTime must be greater than InTime.', type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(result => {
        // if (this.common.PageRight.IsAdd) {
          if (result) {
            this.isDisabled = true;
            this.Regularization.RegularizationAttendanceDetails.forEach((element: any) => {
              if (element.IsIn) {
                this.RegularizationForSave.RegularizationAttendanceDetails.push({
                  EmpMasterId: element.EmpMasterId,
                  DesignationID: element.DesignationID,
                  DutyID: element.DutyID,
                  BranchID: element.BranchID,
                  SiteID: element.SiteID,
                  ShiftMasterID: element.ShiftMasterID,
                  AttendanceDate: element.AttendanceDate,
                  InTime: moment(element.AttendanceDate)
                    .add(element.InTime.hour, 'hours')
                    .add(element.InTime.minute, 'minutes')
                    .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  OutTime: null,
                  InReason: element.InReason,
                  OutReason: null,
                  AttendanceStatus: 'IN'
                });

              }
              if (element.IsOut) {
                this.RegularizationForSave.RegularizationAttendanceDetails.push({
                  EmpMasterId: element.EmpMasterId,
                  DesignationID: element.DesignationID,
                  DutyID: element.DutyID,
                  BranchID: element.BranchID,
                  SiteID: element.SiteID,
                  ShiftMasterID: element.ShiftMasterID,
                  AttendanceDate: element.AttendanceDate,
                  InTime: null,
                  OutTime: moment(element.AttendanceDate)
                    .add(element.IsRotationalShift ? 1 : 0, 'day')
                    .add(element.OutTime.hour, 'hours')
                    .add(element.OutTime.minute, 'minutes')
                    .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  InReason: null,
                  OutReason: element.OutReason,
                  AttendanceStatus: 'OUT'
                });
              }
            });
            this._Regularization.SaveRegularizationAttendance(this.RegularizationForSave).subscribe({
              next: (response) => {
                if (response.Error_Code == '01') {
                  this.RegularizationForSave.RegularizationAttendanceDetails = [];
                  this.Regularization.RegularizationAttendanceDetails = [];
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.close();
                    }
                  });
                }
                else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        // }
        // else {
        //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        // }
      }, reason => { });
    }
  }

  // SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
  //   this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
  //     next: (response) => {
  //       console.log(response);
  //       if (SelectType == 'RegistrationDate') {
  //         this.MaxDate = moment(response.Table[0].RegistrationDate);
  //         this.MinDate = moment(Date.UTC(this.MaxDate.year(), this.MaxDate.month(), 1));
  //         //this.MinDate.add({ month: 1 })
  //       }
  //     },
  //     complete: () => {
  //       const Datemoment = this.MaxDate;
  //       const MinMoment = this.MinDate
  //       this.MaxDate.Date = {
  //         year: Datemoment.year(),
  //         month: Datemoment.month() + 1 + 1, // NgbDateStruct month is 1-based
  //         day: Datemoment.date(),
  //       };

  //       this.MinDate.Date = {
  //         year: MinMoment.year(),
  //         month: MinMoment.month() + 1 + -1, // NgbDateStruct month is 1-based
  //         day: MinMoment.date(),
  //       }
  //     },
  //     error: (error) => { },
  //   });
  // }

  timeFormate(event: any, type: String, index: number) {
    if (type == 'InTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].InTime.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].InTime.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'OutTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].OutTime.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].OutTime.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }

  close() {
    this.activeModal.close(true);
  }

}
